import React, { useEffect, useRef } from 'react';

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const SCRIPT_URL = 'https://accounts.google.com/gsi/client';

let scriptPromise = null;
const loadGoogleScript = () => {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = SCRIPT_URL;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        scriptPromise = null;
        reject(new Error('Could not load Google sign-in'));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
};

// Google's own "Sign in with Google" button. onCredential receives the ID token.
export default function GoogleSignInButton({ onCredential, onError }) {
  const container = useRef(null);
  // Google keeps the first callback it is given, so route it to the latest prop
  const latestOnCredential = useRef(onCredential);
  latestOnCredential.current = onCredential;

  useEffect(() => {
    if (!CLIENT_ID) return undefined;
    let cancelled = false;
    loadGoogleScript()
      .then(() => {
        if (cancelled || !container.current) return;
        window.google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: (response) => latestOnCredential.current(response.credential)
        });
        window.google.accounts.id.renderButton(container.current, {
          theme: 'filled_blue',
          size: 'large',
          shape: 'pill',
          text: 'signin_with'
        });
      })
      .catch(() => onError && onError());
    return () => {
      cancelled = true;
    };
    // Render once per mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={container} className="disease-game-google-button" />;
}
